<script setup>
import OrderForm from './components/OrderForm.vue'
</script>

<template>
  <div>
    <div class="app-header">
      <h1>Wprowadź swoje dane</h1>
      <p>żeby móc korzystać z aplikacji, utwórz konto</p>
    </div>
    <order-form />
  </div>
</template>

<style scoped>
.app-header {
  padding-top: 1rem;
  padding-bottom: 2.5rem;
  color: #000;
  text-align: center;
}

h1 {
  font-size: 1.5rem;
  font-weight:800;
}
</style>